import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from 'react';
interface AlvieCopilotState {
  _alvie_chat_id?: string;
  _alvie_chat_title?: string;
  chat_id?: string;
}
interface UseCopilotAgentChatMetaSyncArgs {
  agentState: AlvieCopilotState | undefined;
  currentChatId: string | null;
  onChatIdChange?: (chatId: string) => void;
  onTitleGenerated?: (chatId: string) => void;
  lastEmittedChatIdRef: RefObject<string | null>;
  titleFiredForChatRef: RefObject<string | null>;
}

/** Emits chat id/title callbacks from agent.state and resets tracking refs when chat clears. */
export const useCopilotAgentChatMetaSync = t0 => {
  const $ = _c(25);
  const {
    agentState,
    currentChatId,
    onChatIdChange,
    onTitleGenerated,
    lastEmittedChatIdRef,
    titleFiredForChatRef
  } = t0;
  let t1;
  if ($[0] !== agentState?._alvie_chat_id || $[1] !== agentState?.chat_id || $[2] !== lastEmittedChatIdRef || $[3] !== onChatIdChange) {
    t1 = () => {
      const chatId = agentState?._alvie_chat_id ?? agentState?.chat_id;
      if (chatId != null && chatId !== lastEmittedChatIdRef.current && onChatIdChange != null) {
        lastEmittedChatIdRef.current = chatId;
        onChatIdChange(chatId);
      }
    };
    $[0] = agentState?._alvie_chat_id;
    $[1] = agentState?.chat_id;
    $[2] = lastEmittedChatIdRef;
    $[3] = onChatIdChange;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = agentState?._alvie_chat_id;
  const t3 = agentState?.chat_id;
  let t4;
  if ($[5] !== lastEmittedChatIdRef || $[6] !== onChatIdChange || $[7] !== t2 || $[8] !== t3) {
    t4 = [t2, t3, lastEmittedChatIdRef, onChatIdChange];
    $[5] = lastEmittedChatIdRef;
    $[6] = onChatIdChange;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t1, t4);
  let t5;
  if ($[10] !== agentState?._alvie_chat_title || $[11] !== currentChatId || $[12] !== onTitleGenerated || $[13] !== titleFiredForChatRef) {
    t5 = () => {
      const title = agentState?._alvie_chat_title;
      if (title != null && title.length > 0 && currentChatId != null && titleFiredForChatRef.current !== currentChatId) {
        titleFiredForChatRef.current = currentChatId;
        onTitleGenerated?.(currentChatId);
      }
    };
    $[10] = agentState?._alvie_chat_title;
    $[11] = currentChatId;
    $[12] = onTitleGenerated;
    $[13] = titleFiredForChatRef;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = agentState?._alvie_chat_title;
  let t7;
  if ($[15] !== currentChatId || $[16] !== onTitleGenerated || $[17] !== t6 || $[18] !== titleFiredForChatRef) {
    t7 = [t6, currentChatId, onTitleGenerated, titleFiredForChatRef];
    $[15] = currentChatId;
    $[16] = onTitleGenerated;
    $[17] = t6;
    $[18] = titleFiredForChatRef;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  useEffect(t5, t7);
  let t8;
  let t9;
  if ($[20] !== currentChatId || $[21] !== lastEmittedChatIdRef || $[22] !== titleFiredForChatRef) {
    t8 = () => {
      if (currentChatId == null) {
        titleFiredForChatRef.current = null;
        lastEmittedChatIdRef.current = null;
      }
    };
    t9 = [currentChatId, lastEmittedChatIdRef, titleFiredForChatRef];
    $[20] = currentChatId;
    $[21] = lastEmittedChatIdRef;
    $[22] = titleFiredForChatRef;
    $[23] = t8;
    $[24] = t9;
  } else {
    t8 = $[23];
    t9 = $[24];
  }
  useEffect(t8, t9);
};